import {
  arrayBuilderItemFirstPageTitleUI,
  fileInputUI,
  fileInputSchema,
  selectUI,
  selectSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { MISSING_FILE } from 'platform/forms-system/src/js/validation';
import {
  FILE_TYPES,
  UPLOAD_URL,
} from '../../../../shared/components/fileInputComponent/constants';
import {
  MAX_FILE_SIZE_BYTES,
  MAX_PDF_FILE_SIZE_BYTES,
} from '../../../../shared/constants';
import {
  createPayload,
  parseResponse,
} from '../../../../shared/utils/fileInputMultiUIConfig';
import {
  STR_ATTACHMENT_LABELS,
  STR_HINT_TEXT,
  serviceTreatmentRecordsOptions,
} from './options';

/**
 * Upload (item) page: single file upload plus a record-type select rendered
 * as a separate form control (decoupled from the file card, per the VADS
 * recommendation).
 */
export default {
  uiSchema: {
    ...arrayBuilderItemFirstPageTitleUI({
      title: 'Upload your service treatment records',
      nounSingular: serviceTreatmentRecordsOptions.nounSingular,
      hasMultipleItemPages: false,
    }),
    uploadedDocument: {
      ...fileInputUI({
        title: 'Upload your service treatment records to support your claim',
        hint: STR_HINT_TEXT,
        required: () => true,
        accept: FILE_TYPES,
        fileUploadUrl: UPLOAD_URL,
        formNumber: '21-526EZ',
        fileSizesByFileType: {
          pdf: {
            maxFileSize: MAX_PDF_FILE_SIZE_BYTES,
            minFileSize: 1024,
          },
          default: {
            maxFileSize: MAX_FILE_SIZE_BYTES,
            minFileSize: 1,
          },
        },
        errorMessages: { required: MISSING_FILE },
        createPayload,
        parseResponse,
      }),
      'ui:validations': [
        // Needed for validation to work correctly inside arrays; taken from
        // the ownedAssetPages.js precedent.
        // https://va.ghe.com/software/vets-design-system-documentation/issues/4837
        (errors, fieldData) => {
          if (fieldData?.isEncrypted && !fieldData?.confirmationCode) {
            return;
          }
          if (!fieldData || !fieldData.name) {
            errors.addError(MISSING_FILE);
          }
          if (fieldData?.errorMessage) {
            errors.addError(fieldData.errorMessage);
          }
        },
      ],
    },
    attachmentId: selectUI({
      title: 'What type of record is this?',
      required: () => true,
      labels: STR_ATTACHMENT_LABELS,
      errorMessages: { required: 'Choose a document type' },
      // explicit aria-describedby text, read together with the select's label.
      messageAriaDescribedby: 'Choose the type of record you uploaded above.',
    }),
  },
  schema: {
    type: 'object',
    required: ['uploadedDocument', 'attachmentId'],
    properties: {
      uploadedDocument: fileInputSchema(),
      attachmentId: selectSchema(Object.keys(STR_ATTACHMENT_LABELS)),
    },
  },
};
